import { render, staticRenderFns } from "./FlagIcon.vue?vue&type=template&id=d37f9332&scoped=true"
import script from "./FlagIcon.vue?vue&type=script&lang=js"
export * from "./FlagIcon.vue?vue&type=script&lang=js"
import style0 from "./FlagIcon.vue?vue&type=style&index=0&id=d37f9332&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d37f9332",
  null
  
)

export default component.exports